import { DefaultText } from "@/UI"
import DisplayPrice from "@/UI/DataDisplay/DisplayPrice"
import { currencyAtom } from "@/atoms/currencyAtom"
import { getSingleRuleCouriers } from "@/atoms/dispatchRulesAtom"
import { IDispatchRule, DispatchRuleType } from "@/types/dispatchRules.types"
import { getDeliveryTypeLabel } from "@/utils/delivery.utils"
import { vehicleImage } from "@/utils/providers"
import { faClone } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { message, Card, Descriptions } from "antd"
import { capitalize } from "lodash"
import { useTranslation } from "react-i18next"
import { useRecoilValue } from "recoil"
import Image from "next/image"
import ProvidersList from "../../../ProvidersList/ProvidersList.container"
import { ProvidersType } from "@/types/providers.types"
import { assignmentTypeNames } from "@/types/draftOrder.types"

// TODO: Full and compact view could share the logic
const CompactViewDispatchRuleCard: React.FC<{ rule: IDispatchRule }> = ({ rule }) => {
  const { t } = useTranslation()

  const currency = useRecoilValue(currencyAtom)

  const priorityMap = {
    [DispatchRuleType.ETA]: t("common.fastest"),
    [DispatchRuleType.PRICE]: t("common.cheapest"),
    [DispatchRuleType.RANK]: t("common.ranking"),
    [DispatchRuleType.ZONE]: t("common.zones"),
  }

  const handleRuleIdCopy = (ruleId: string) => {
    navigator.clipboard?.writeText(ruleId)
    message.success(t("profile.CustomerPortals.copyUrlSuccess"))
  }
  const { name, ruleId, priority, maxPrice, deliveryType, vehicleType } = rule
  const ruleCouriers = useRecoilValue(getSingleRuleCouriers(rule?.id))
  const assignmentType = rule?.couriers?.find(
    (courier) => courier?.provider === ProvidersType.OWN_FLEET
  )?.assignmentType
  return (
    <Card styles={{ body: { padding: "0.5em" } }} className="text-sm border-0">
      <Descriptions
        title={
          <div className="flex items-center flex-wrap">
            <span className="mr-1.5">{name}</span>
            <div className="text-sm font-normal space-x-1">
              <span>{ruleId}</span>
              <FontAwesomeIcon
                onClick={() => handleRuleIdCopy(ruleId)}
                className="text-gray-500 text-sm cursor-pointer"
                icon={faClone}
              />
            </div>
          </div>
        }
        size={"small"}
        bordered
        labelStyle={{ fontSize: "0.75rem", padding: "4px 8px" }}
        contentStyle={{ fontSize: "0.75rem", padding: "4px 8px" }}
        column={1}
      >
        <Descriptions.Item label={t("profile.DispatchRules.priority")}>
          {capitalize(priorityMap[priority])}
        </Descriptions.Item>
        {!!maxPrice && (
          <Descriptions.Item label={t("profile.DispatchRules.maxDeliveryFee")}>
            <DisplayPrice amount={maxPrice} currencyCode={currency.code} justify="start" isCents />
          </Descriptions.Item>
        )}
        {!!deliveryType && (
          <Descriptions.Item label={t("common.order-field.deliveryType")}>
            {getDeliveryTypeLabel(deliveryType)}
          </Descriptions.Item>
        )}
        {!!vehicleType && (
          <Descriptions.Item label={t("common.order-field.vehicleType")}>
            <div className="flex items-center">
              <Image src={vehicleImage(vehicleType)} priority={true} width={24} height={24} />
            </div>
          </Descriptions.Item>
        )}
      </Descriptions>
      {!!assignmentType && (
        <Descriptions.Item label={t("common.assignmentType")}>
          {t(assignmentTypeNames[assignmentType])}
        </Descriptions.Item>
      )}
      <div className="flex flex-col mt-2">
        <DefaultText className="ml-0.5">
          {t("profile.DispatchRuleCard.amongProviders")}:
        </DefaultText>
        <ProvidersList
          providers={ruleCouriers}
          view={"compact"}
          type={rule.priority}
          className={`!mt-1 w-full`}
        />
      </div>
    </Card>
  )
}

export default CompactViewDispatchRuleCard
